import { getMenusByTemplate, getModulesByTemplate, getProjectByTemplate } from '@haohan/clw-api'
import { useEvent, useProject, useUser } from '@haohan/clw-store'
import { getTemplatePreviewInfo } from '@haohan/clw-utils'
/**
 *
 * @returns 模板相关
 */
export const useTemplate = () => {
  const projectStore = useProject()
  const userStore = useUser()
  const eventStore = useEvent()
  const initInfoByTemplateId = async (routeParams: any) => {
    console.log('初始化模板信息')
    const { moudleId } = routeParams
    const templateInfo = getTemplatePreviewInfo()
    // 加载项目信息
    // 获取当前项目信息
    // 获取当前项目信息
    const projectRes = await getProjectByTemplate(templateInfo.templateId)
    projectStore.changeCurrentProject(projectRes.data)
    // 获取当前模板信息
    const moduleRes = await getModulesByTemplate(templateInfo.templateId, { page: 1, size: 100 })
    const _currentModule = moudleId
      ? moduleRes.data.data.find((item) => item.id === moudleId)
      : moduleRes.data.data[0]
    projectStore.changeCurrentModule(_currentModule)
    // 获取当前页面信息
    const pageRes = await getMenusByTemplate(templateInfo.templateId as string, _currentModule.id)
    projectStore.changePages(pageRes.data)
    // 初始化信息
    await userStore.getInfo()
    await userStore.getRegionInfo()
    await projectStore.getProjectInfo(projectRes.data.id)
    eventStore.loadCommonParameters(projectStore.currentProject)
    eventStore.initAllPageDialogEvent()
  }
  return {
    initInfoByTemplateId
  }
}
